<template>
  <div class="container">
    <div>
      <el-form
        inline
        size="mini"
        label-width="45px"
        class="table-search-part"
        @submit.native.prevent="handleQuery()"
      >
        <div style="display: flex;justify-content: space-between;width: 100%;">
          <div>
            <el-form-item>
              <el-button class="add-new-btn" @click="handleChange(1)">
                <i class="iconfont iconProperty1tianjia"></i> New Observed List
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button class="add-new-btn" @click="handleChange(2)">
                <i class="iconfont iconProperty1tianjia"></i> New White List
              </el-button>
            </el-form-item>
            <el-form-item label="IP Type" style="margin-right: 10px;">
              <el-select
                v-model="queryData.managementType"
                placeholder="Please Select IP Type"
                filterable
                clearable
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in ipTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="IP Search" style="margin-right: 10px;">
              <el-input v-model="queryData.ip" placeholder="IP Search" clearable></el-input>
            </el-form-item>
            <el-button class="search-btn" @click="handleQuery()">Search</el-button>
          </div>
          <el-form-item style="margin-right: 10px;background: #F8F8F8;">
            <el-button class="lebel-risk-export-btn" id="download" @click="handleExport()">
              <i class="icon iconfont iconProperty1xiazai" style="font-size: 16px;"></i>
              Download
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="syslog-table">
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        stripe
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column type="index" label="Number" width="70" align="center"></el-table-column>
        <el-table-column prop="managementType" label="IP Type" width="120">
          <template v-slot="{ row }">
            <div v-if="row.managementType">{{ row.managementType === 1 ? "Observed" : "White" }}</div>
          </template>
        </el-table-column>
        <el-table-column label="IP" prop="ip" min-width="120"></el-table-column>
        <el-table-column label="Time" prop="createTime" min-width="200" align="center">
          <template v-slot="{ row }">
            <div v-if="row.createTime">{{ formatUtc(row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Operator" prop="operateUser" min-width="100" align="center"></el-table-column>
        <el-table-column label="Remark" prop="remark" min-width="200"></el-table-column>
        <el-table-column label="Operation" min-width="140">
          <template v-slot="{ row }">
            <div>
              <el-button
                class="table-inner-btn view-order-btn"
                @click="handleChange(3, row.ip)"
              >Release</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <dia ref="dialogDom" class="label-dialog">
      <div v-if="num == 2 || num == 1">
        <el-form :model="form" label-width="156px">
          <el-form-item label="IP">
            <!-- <el-input style="width:72.5%;" v-model="form.ip" placeholder="Input IP"></el-input> -->
            <el-input-tag v-model="form.ips" style="width: 220px" />
          </el-form-item>
          <el-form-item label="Remark">
            <el-input style="width:72.5%;" v-model="form.remark" placeholder="Remark"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleViewAdd()">Confirm</el-button>
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
      <!-- 删除3 -->
      <div class="dialog-footer table-search-part" v-if="num == 3">
        <el-button class="search-btn" @click="releaseIp()">Confirm</el-button>
        <el-button class="clear-btn" @click="Close()">Cancel</el-button>
      </div>
    </dia>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dia from "@/components/dialog/index";
import Empty from "@/components/empty/index";
import ElInputTag from "./ElInputTag.vue";
import {
  createIpManagement,
  getIpManagementList,
  releaseIpManagement,
  getExport
} from "@/api/ip";
// function checkIpv6(ip) {
//   const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
//   const valdata = ip.split(",");
//   for (let i = 0; i < valdata.length; i++) {
//     if (reg.test(valdata[i]) == false) {
//       return false;
//     }
//   }
//   return true;
// }
// const checkIp = (rule, value, callback) => {
//   if (!value.length) {
//     return callback(new Error("IP地址不能为空！"));
//   } else if (!checkIpv6(value.join(","))) {
//     return callback(new Error("请输入正确的IP地址！"));
//   } else {
//     callback();
//   }
// };
export default {
  name: "IPManagementList",
  data() {
    return {
      list: [],
      total: 0,
      num: "",
      loading: false,
      form: {
        ips: [],
        managementType: 1,
        remark: ""
      },
      ipTypeList: [
        { id: 1, name: "Observed" },
        { id: 2, name: "White" }
      ],
      queryData: {
        current: 1,
        size: 50,
        ip: "",
        managementType: ""
      },
      rowIp: "",
      showOverflow: false,
      tableHeight: window.innerHeight
      // rules: {
      //   ip: [
      //     { required: true, validator: checkIp, trigger: ["blur", "change"] }
      //   ]
      // }
    };
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await getIpManagementList(this.queryData);
        if (res.data) {
          const data = res.data || {};
          this.list = data.records || [];
          this.total = data.total;
        } else {
          this.$message({ message: res.message, type: "warning" });
        }
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    handleChange(num, data) {
      this.num = num;
      if (num == 1) {
        // 添加
        this.title = "New Observed";
        this.form = {
          ips: [],
          managementType: 1,
          remark: ""
        };
      } else if (num == 2) {
        // 添加2
        this.title = "New White";
        this.form = {
          ips: [],
          managementType: 2,
          remark: ""
        };
      } else {
        // 删除
        this.title = "Release IP?";
        this.rowIp = data;
      }
      this.$refs["dialogDom"].isShowDia(this.title, true, "500px");
    },
    // 添加
    async handleViewAdd() {
      if (!this.form.ips) {
        this.$message({
          message: "The IP can not be empty",
          type: "warning"
        });
        return false;
      }
      // if (!this.isValidIP(this.form.ip)) {
      //   this.$message({
      //     message: "The IP Check Failed",
      //     type: "warning"
      //   });
      //   return false;
      // }
      try {
        const res = await createIpManagement(this.form);
        if (res.success) {
          this.$message({
            message: "add success",
            type: "success"
          });
          this.getList();
        } else {
          this.$message({
            message: res.message,
            type: "warning",
            duration: 30000,
            showClose: true
          });
        }
        this.Close();
      } catch {}
    },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "500px");
    },
    isValidIP(val) {
      var reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5]|\*)$/;
      return reg.test(val);
    },
    handleExport() {
      let timeZoneOffset = this.$moment().utcOffset() / 60;
      let param = { ...this.queryData, timeZoneOffset: timeZoneOffset };
      delete param.size;
      delete param.current;
      getExport(param, "export.xlsx");
    },
    // 搜索
    handleQuery() {
      this.queryData.current = 1;
      this.getList();
    },
    // 清除搜索
    handleClearQuery() {
      this.handleClear();
      this.getList();
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    async releaseIp(row) {
      let param = { ip: this.rowIp };
      const res = await releaseIpManagement(param);
      if (res.success) {
        this.$message({ message: "release success", type: "success" });
        this.Close();
        this.getList();
      }
    }
  },
  components: {
    dia,
    Empty,
    ElInputTag
  },
  mounted() {
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.table-search-part {
  padding: 0;
  .el-form-item--mini.el-form-item {
    margin-bottom: 18px;
  }
}
.add-new-btn {
  height: 29px;
  margin-right: 15px;
}
.el-button--mini {
  padding: 8px 15px 7px !important;
}
.last-input {
  margin: 0 20px 0 0 !important;
}
.userId-item::after {
  display: inline-block;
  content: ",";
}
.userId-item:last-child {
  &::after {
    display: none;
  }
}
/deep/.el-form-item__label {
  width: 60px !important;
}
/deep/.el-button:hover,
.el-button:focus {
  color: #24b681;
  border-color: #24b681;
  background-color: #e9f8f2;
}
</style>
